<template>
  <v-container class="content ma2">
    <div data-aos="fadeInUp">
      <div class="display-2 text--center">
        <span>HYDROVAC</span>
        <span class="font-weight-light">KING</span>
      </div>
      <div class="grey--text subheading">The royal choice</div>
    </div>

    <blockquote class="blockquote">Need to hire a hydrovac?  Our trained staff have proven time and time again to handle even your most difficult excavation.  We offer services ranging from a simple trench to your more complicated excavation.  We have a highly trained workforce that are egar to work with your team in completing the project.</blockquote>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-card class="ma-2" data-aos="fadeInUp">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">WHAT IS HYDROVAC EXCAVATION?</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span>Hydrovac excavation is a safe process where high pressure water is used to loosen and break up all different types of earth. Once the ground material is broken up and loose it is then vacuumed up into the hydrovac truck. From there it is taken and displosed of at the proper facility. Our trucks are also equipped with heaters so that they can work in year round conditions, and even tackle frozen ground safely.</span>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card class="ma-2" data-aos="fadeInUp">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">WHAT CAN A HYDROVAC TRUCK OFFER</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span>Hydrovac trucks can complete a variety of services which include but are not limited to...</span>
            <ul>
              <li>Daylighting</li>
              <li>Trenching</li>
              <li>Pole Hole Excavation</li>
              <li>Tank Cleanouts</li>
              <li>Curb box Replacement</li>
              <li>Debris Removal</li>
              <li>Shoring Installation</li>
              <li>Service Pits</li>
              <li>Frozen Ground Excavation</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-divider class="my-5"></v-divider>

    <v-layout row wrap style="margin:10px 0;" data-aos="fadeInUp">
      <v-flex xs12>
        <p class="headline text-xs-center">Advantages of a Hydrovac Truck</p>
      </v-flex>

      <v-flex xs4>
        <p class="title text-xs-center">Hydrovac Services</p>
      </v-flex>
      <v-flex xs4>
        <p class="title text-xs-center">VS</p>
      </v-flex>
      <v-flex xs4>
        <p class="title text-xs-center">Mechanical Digging</p>
      </v-flex>

      <v-flex xs4>
        <p
          class="body-2 text-xs-center"
        >Hydrovac's successfully expose utility and pipes without damage and less likely to have a trench cave in.</p>
      </v-flex>
      <v-flex xs4>
        <p class="body-2 text-xs-center">SAFETY</p>
      </v-flex>
      <v-flex xs4>
        <p
          class="body-2 text-xs-center"
        >Mechanical digging has a high risk of utility and pipe strikes which would put workers and public at risk.</p>
      </v-flex>

      <v-flex xs4>
        <p
          class="body-2 text-xs-center"
        >Hydrovac's remove all the debris and leave the job site clean.</p>
      </v-flex>
      <v-flex xs4>
        <p class="body-2 text-xs-center">JOB SITE DISRUPTION</p>
      </v-flex>
      <v-flex xs4>
        <p class="body-2 text-xs-center">Mechanical digging can cause quite a lot of destruction.</p>
      </v-flex>

      <v-flex xs4>
        <p
          class="body-2 text-xs-center"
        >Hydrovac's cause less damage to the environment and can effectively remove contaminated soil quickly.</p>
      </v-flex>
      <v-flex xs4>
        <p class="body-2 text-xs-center">DAMAGE RISKS</p>
      </v-flex>
      <v-flex xs4>
        <p
          class="body-2 text-xs-center"
        >Mechanical digging will often need to have a person hand dig and cause a utility stike that are dangerous and costly to fix.</p>
      </v-flex>

      <v-flex xs4>
        <p class="body-2 text-xs-center">Hydrovac's require less manpower and cost to operate.</p>
      </v-flex>
      <v-flex xs4>
        <p class="body-2 text-xs-center">LABOUR</p>
      </v-flex>
      <v-flex xs4>
        <p
          class="body-2 text-xs-center"
        >Mechanical digging and hand diggings are expensive and will cost more if any errors occur.</p>
      </v-flex>

      <v-flex xs4>
        <p
          class="body-2 text-xs-center"
        >Hydrovac's can work in all climate's which means time efficiency.</p>
      </v-flex>
      <v-flex xs4>
        <p class="body-2 text-xs-center">WEATHER</p>
      </v-flex>
      <v-flex xs4>
        <p
          class="body-2 text-xs-center"
        >Mechanical digging is not productive in the winter in Canada which can result in major production delays.</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
</style>